import React, {useEffect} from 'react'
import settings from '../conf'
import Icons from '../images/error.svg'
import api from '../api'

import {
  PAGE_NOT_FOUND,
  GO_TO_HOME_PAGE
} from '../trans'

const Page404 = () => {

  const [
    logError,     
    result
  ] = api.useLoggingErrorMutation()

  useEffect(()=>{
    logError({
      url: window.location.href,
      title: 'page not found (404)',
      stack: '<empty>'
    })  
  }, [])

  return (
    <div className="pwa__error fade-in">
      <div className="content fade-in delay">
        <Icons/>
        <h2>
          {PAGE_NOT_FOUND}
        </h2>
        <button className="button secondary" onClick={() => window.location.href=settings.HOME_URL}>
          {GO_TO_HOME_PAGE}
        </button>
      </div>
    </div>
  )
}

export default Page404
